import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import {ForgotPasswordPage} from "./ForgotPasswordPage";
import {ResetPasswordPage, SetPasswordPage} from "./ResetPasswordPage";
import App from "../App";
import React from "react";
import LayoutMain from "../layouts/LayoutMain";
import {adminPath} from "../routing/appRoutes";

export function RouterComponent() {
  return <BrowserRouter>
    <Routes>
      {/* Forgot Password - Request Reset Email */}
      <Route path="/forgot-password" element={<ForgotPasswordPage/>}/>

      {/* Reset Password - Link with Token */}
      <Route path="/reset-password" element={<ResetPasswordPage/>}/>

      {/* Set Password - invitation link from the welcome email (same endpoint, welcome copy).
          Public and outside /admin, /internal (the edge nginx 403s those). */}
      <Route path="/set-password" element={<SetPasswordPage/>}/>

      <Route path="/" element={<App/>}>
        {/* Legacy standalone admin pages now live under /settings */}
        <Route path="users/*" element={<Navigate to={adminPath('users')} replace/>}/>
        <Route path="analytic-profiles/*" element={<Navigate to={adminPath('analytic-profiles')} replace/>}/>

        {/* Every app view (and Not Found) is resolved inside LayoutMain from the URL; see routing/appRoutes.ts.
            One catch-all route keeps LayoutMain mounted while navigating between views. */}
        <Route index element={<LayoutMain/>}/>
        <Route path="agent-studio" element={<Navigate to="/settings/models" replace/>}/>
        <Route path="applications" element={<Navigate to="/settings/applications" replace/>}/>
        <Route path="*" element={<LayoutMain/>}/>
      </Route>
    </Routes>
  </BrowserRouter>;
}
